module.exports = __webpack_public_path__ + "media/flags/pt-3b962b6d.png";